import React, { useContext, useEffect } from 'react';

import { PagesContext } from '../store/PagesContext';

import greenPolygon from '../assets/images/svg/green-polygon.svg';
import star from '../assets/images/star-green.png';
import bee from '../assets/images/bee.png';

import Intro from 'routes/decision-trees/components/Intro';
import Description from 'routes/decision-trees/components/Description';
import Hint from 'routes/decision-trees/components/Hint';

const IsoInitial = () => {
  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage(''), []);

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <Intro background={greenPolygon} withCongrats={star} withBee={bee}>
        <h2>
          Congrats,
          <br />
          you exercised
          <br />
          your ISOs!
        </h2>
      </Intro>

      <Description>
        <p>
          You&apos;re probably aware that there was no ordinary income tax generated when you exercised your ISOs. And while this is one of
          the most exciting things about ISOs, you still have implications on your tax liabilities that will impact your financial future –
          this tree can help you discover those liabilities!
        </p>
        <p>
          Regardless of which path you choose for your ISOs, your tax professional will use IRS Form 3921 to calculate the AMT impact of the
          exercise.
        </p>
      </Description>

      <Hint>Click anywhere on the screen to get started.</Hint>
    </div>
  );
};

export default IsoInitial;
